import { render } from "./B2bLoginPasswordFormRee.vue?vue&type=template&id=0a7f2b01&scoped=true&lang=pug"
import script from "./B2bLoginPasswordFormRee.vue?vue&type=script&lang=js"
export * from "./B2bLoginPasswordFormRee.vue?vue&type=script&lang=js"

import "./B2bLoginPasswordFormRee.vue?vue&type=style&index=0&id=0a7f2b01&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a7f2b01"]])

export default __exports__